import React from "react";

export const PITCH_CONTEXT_FIELD_PLACEHOLDER =
  "Example: Mention our free trial when it helps. If the recipient reads as a founder, add a short founder story. For smaller companies, highlight self-serve instead of leading with our calendar link. Do not claim SOC 2 certification.";

export function PitchContextFieldLabel() {
  return <span>Custom context for your replies</span>;
}
